import { useParams } from 'react-router-dom';
import CaseDetail from '../pages/CaseDetail';
import DynamicPage from '../pages/DynamicPage';
import EventDetail from '../pages/EventDetail';
import InsightDetail from '../pages/InsightDetail';
import PartnerDetail from '../pages/PartnerDetail';
import ProjectDetail from '../pages/ProjectDetail';

export const dynamicPageRoutes = [
  { path: '/', slugOverride: 'home' },
  { path: '/about', slugOverride: 'about' },
  { path: '/services', slugOverride: 'services' },
  { path: '/contact', slugOverride: 'contact' },
  { path: '/invest', slugOverride: 'invest' },
  { path: '/tours', slugOverride: 'tours' },
  { path: '/tours/travel', slugOverride: 'tours-travel' },
  { path: '/tours/business', slugOverride: 'tours-business' },
  { path: '/tours/retreat', slugOverride: 'tours-retreat' },
  { path: '/tours/production', slugOverride: 'tours-production' },
  { path: '/partners', slugOverride: 'partners' },
  { path: '/events', slugOverride: 'events' },
  { path: '/cases', slugOverride: 'cases' },
  { path: '/insights', slugOverride: 'insights' },
  { path: '/nda', slugOverride: 'nda' },
  { path: '/privacy', slugOverride: 'privacy' },
  { path: '/terms', slugOverride: 'terms' },
  { path: '/download', slugOverride: 'download' },
];

export const detailRoutes = [
  { path: '/events/:slug', element: EventDetail },
  { path: '/cases/:slug', element: CaseDetail },
  { path: '/insights/:slug', element: InsightDetail },
  { path: '/partners/:slug', element: PartnerDetail },
  { path: '/invest/:slug', element: ProjectDetail },
];

export const extraDynamicRoutes = [
  { path: '/services/:slug', element: ServiceDynamic },
  { path: '/pages/:slug', element: DynamicPage },
];

function ServiceDynamic() {
  const { slug } = useParams();
  return <DynamicPage slugOverride={`service-${slug}`} />;
}
